import Cookies from "js-cookie";

enum CookieName {
  Jwt = "jwt_token",
  LoggedOutUuid = "logged_out_uuid",
}

export const getJwt = () =>
  // Treat REACT_APP_DUOLINGO_JWT = "" as falsy
  process.env.REACT_APP_DUOLINGO_JWT
    ? process.env.REACT_APP_DUOLINGO_JWT
    : Cookies.get(CookieName.Jwt);

export const getLoggedOutUuid = () => Cookies.get(CookieName.LoggedOutUuid);
